import CompleteApiModel from '@widesk-ui/models/CompleteApiModel';

export default abstract class ServiceModel extends CompleteApiModel {
	fetchLabel?(): Promise<void>;
}